/** Giống nhau */
/**
 * TODO: Chưa làm cái này vì mới phát hiện ra là có nó
 * @link https://shopify.github.io/liquid/filters/escape_once/
 */
export const escape_once = (liquid: string) => liquid;
